import { put, takeLatest, delay } from "redux-saga/effects";
import { postValidatePasswordApi } from "store/api/LoginApi";
import { VALIDATE_PASSWORD_ACTION } from "../../actions/LoginPageAction/actionTypes";

import * as globalAction from "../../actions/GlobalAction";

function* showMessage(isError, message) {
	const alert = { isError: isError, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* postValidatePassword(action) {
	const { password, onSuccess } = action.params;
	yield put(globalAction.openLoadingPage());
	const res = yield postValidatePasswordApi({ password: password });
	try {
		if (res?.code === 0) {
			onSuccess();
		} else {
			yield showMessage(true, res?.message);
		}
		yield delay(500);
	} catch (e) {
		console.log(e);
	} finally {
		yield put(globalAction.closeLoadingPage());
	}
}

function* postValidatePasswordSaga() {
	yield takeLatest(VALIDATE_PASSWORD_ACTION, postValidatePassword);
}

export default postValidatePasswordSaga;
